const RETRY_TIMEOUT = 30_000;
const ABORT_TIMEOUT = 30_000;
const FQDN_HOSTS    = ['mail.ru', 'ya.ru', 'vk.ru'];
const CUSTOM_EVENT_INTERNET_AVAILABILITY = 'internetAvailability';

const customEventInternetAvailability = new CustomEvent(
    CUSTOM_EVENT_INTERNET_AVAILABILITY,
    {
        detail: {
            isPublicInternetAvailability: true
        }
    }
);

const getURL = (httpSecure: boolean) => (fqdn: string) => {
    const url = fqdn.replace(/^(?!(?:\w+?:)?\/\/)/, httpSecure ? 'https://' : 'http://');
    try {
        return new URL(url);
    } catch (e) {
        return false;
    }
};

const checkURL = (signal: AbortSignal) => (url: URL) => {
    const request = new Request(
        url,
        {
            method: 'HEAD',
            mode:   'no-cors',
            signal
        }
    );
    return fetch(request);
};

const checkServerAvailability = (hosts: Array<string>, {timeoutMS = ABORT_TIMEOUT, httpSecure = true} = {}) => {
    const controller = new AbortController();

    const abortTimeoutId = setTimeout(() => controller.abort(), timeoutMS);

    const returnState = (state: boolean) => () => {
        clearTimeout(abortTimeoutId);
        state && document.dispatchEvent(customEventInternetAvailability);
        controller.abort();

        return state;
    };

    const urlList = hosts.map(getURL(httpSecure)).filter(Boolean);

    return Promise.any((urlList.map(checkURL(controller.signal))))
        .then(returnState(true))
        .catch(returnState(false))
    ;
};

export {
    checkServerAvailability,
    RETRY_TIMEOUT,
    FQDN_HOSTS,
    CUSTOM_EVENT_INTERNET_AVAILABILITY
}
